// src/Components/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';  
import { Modal, ModalBody, Button } from 'reactstrap';
import './Login.css';
import logo from '../Assets/App_icon/logo.png';


const Login = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [storeName, setStoreName] = useState('');
  const [cityid, setCityId] = useState('');
  const [cityList, setCityList] = useState([]);
  const [otp, setOtp] = useState('');
  const [modalVisible, setModalVisible] = useState(false); 
  const [enteredOtp, setEnteredOtp] = useState('');
  const [error, setError] = useState('');

  const [selectedsuId, setSelectedsuId] = useState('');
  const [selectedsuName, setSelectedsuName] = useState('');
  const [selectedsuRole, setSelectedsuRole] = useState('');
            

  const navigate = useNavigate();  // Initialize navigate function

  useEffect(() => { 
    const fetchCitiesList = async () => { 
        try {
          const response = await fetch('https://backend.veryfreshmain.in/api/city_list', {
            method: 'POST', // This should be inside the options object
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              selectedLanguage: 'English',
              store: 'veryfreshmain_main',
            }),
          });
          const data = await response.json();
          setCityList(data);
        } catch (error) {
          console.error('Error fetching cities:', error);
        }
        
    }; 
   fetchCitiesList(); 
  }, []);

  useEffect(() => { 
    const storeNameSelect = async () => { 
       if(cityid){
          const selectcity = cityList.find((city) => city.cityId == cityid);
          setStoreName(selectcity.store_name);
       }
    }; 
   storeNameSelect(); 
  }, [cityid]);



  const handleLogin = async () =>  {

    if (!cityid) {
      setError('Please select your city!'); 
      return; 
    } else {
      setError(''); 
      
      if (mobileNumber.length <= 10 && /^[0-9]*$/.test(mobileNumber)){
        
        try {
          const response = await fetch('https://backend.veryfreshmain.in/api/user_login', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              mobileNumber: mobileNumber,
              store: storeName,
            }),
          });

          const data = await response.json(); 
          if(data.mobileNumber === ''){
            alert('Mobile Number Not Registered');
          } else {
            setOtp(data.otp); 
            setSelectedsuId(data.suId.toString());
            setSelectedsuName(data.suName);
            setSelectedsuRole(data.suRole);
            setModalVisible(true);
          }

        } catch (error) {
          console.error('Error fetching categories:', error);
        }

      } else {
        alert('Please enter a valid 10-digit mobile number.');
      }

    }  
  };

  const handleSubmitOtp = () => {
    // OTP validation and proceed to login if valid
    if (enteredOtp === otp) {
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('store', storeName);
      const cityname = cityList.find((city) => city.cityId == cityid);
      localStorage.setItem('cityname', cityname.cityName);
      localStorage.setItem('host_url', cityname.host_url);
      localStorage.setItem('userid', selectedsuId);
      localStorage.setItem('username', selectedsuName);
      localStorage.setItem('userRole', selectedsuRole);
      
      setOtp('');
      setEnteredOtp('');
      navigate('/app');
    } else {
      setError('Invalid OTP. Please try again.');
      setMobileNumber('');
      setOtp('');
      setEnteredOtp('');
      setCityId('');
    }
    setModalVisible(false); 
  };

  return (
    <div className="login-screen">
      <img className="logo-image" src={logo} alt='' style={{ marginBottom: '30px' }}/>

      <div className="form-group">
        <select
          id="cityid"
          value={cityid}
          onChange={(e) => setCityId(e.target.value)}  // Update city selection
        >
          <option value="">Select your city</option>
          {cityList.map((city) => (
            <option key={city.cityId} value={city.cityId}>{city.cityName}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <input
          type="text"
          id="mobileNumber"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          placeholder="Registered Mobile Number"
          maxLength="10"  
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleLogin();  
            }
          }}
        />
      </div>
      
      {error && <p className="error-message">{error}</p>}
      <button onClick={handleLogin}>Login</button>

          {/* Modal for entering OTP */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="otpmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <div className="form-group">
                  <input
                    type="text"
                    value={enteredOtp}
                    onChange={(e) => setEnteredOtp(e.target.value)}
                    placeholder="Enter OTP"
                    maxLength="6"
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        handleSubmitOtp();  
                      }
                    }}
                  />
                </div>
                <Button color="primary" onClick={handleSubmitOtp}>Submit</Button>
              </ModalBody>
            </Modal>
    </div>
  );
};

export default Login;
